@if (moreThanOneLanguage) {
  <div ngbDropdown class="navbar-nav" display="dynamic" placement="bottom-right">
    <button role="button"
            [attr.aria-label]="'nav.language' |translate"
            aria-controls="language-menu-list"
            aria-haspopup="menu"
            class="dropdown-toggle btn btn-link px-0"
            [title]="'nav.language' | translate"
            (click)="$event.preventDefault()" data-toggle="dropdown" ngbDropdownToggle
            data-test="lang-switch"
            tabindex="0">
      <i class="fas fa-globe-asia fa-lg fa-fw"></i>
    </button>
    <div ngbDropdownMenu class="dropdown-menu" [attr.aria-label]="'nav.language' |translate" id="language-menu-list"
         role="listbox">
      @for (lang of translate.getLangs(); track lang) {
        <div class="dropdown-item" tabindex="0"
             role="option"
             [lang]="lang"
             (keyup.enter)="useLang(lang)"
             (click)="useLang(lang)"
             [attr.aria-selected]="lang === translate.currentLang"
             [class.active]="lang === translate.currentLang">
          {{ langLabel(lang) }}
        </div>
      }
    </div>
  </div>
}
